import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EcomNetworkUtils } from '../ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { EComService } from '../ecom-services/ecom-common.service';
import { EComGoogleAnalytics } from '../ecom-services/ecom-google-analytics';
import { EComWebStorage } from '../ecom-services/ecom-webstorage.services';

@Component({
  selector: 'app-ecom-message-redirect',
  templateUrl: './ecom-message-redirect.component.html',
  styleUrls: ['./ecom-message-redirect.component.scss']
})
export class EcomMessageRedirectComponent implements OnInit {

  linkExpired = false;
  constructor(private eComGoogleAnalytics: EComGoogleAnalytics, public ecomservice: EComService, public location: Location,
    public router: Router, public activatedRoute: ActivatedRoute, private webstorage: EComWebStorage) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['O']) {
        const key = params['O'];
        this.getMyIp(key);
      }
      // else if (params['C']) {
      //   this.router.navigate(['items', ""], { queryParams: { webcompanyid: params['C'] } });
      // }
      else if (params['D']) {
        this.router.navigate(['items', ""], { queryParams: { D: params['D'] } });
      }
      // DIEM ADDED NEW
      // TABLE
      else if (params['T'] && (params['U'] || params['u'])) {
        const user = params['U'] || params['u'];

        this.router.navigate(['loginnew'],
          { queryParams: { T: params['T'], U: user, V: Date.now() } });
      }
      else if (params['T']) {
        this.router.navigate(['loginnew'], { queryParams: { T: params['T'], V: Date.now() } });
      } // LOCATION
      else if (params['L'] && params['C'] && (params['U'] || params['u'])) {

        const user = params['U'] || params['u'];

        this.router.navigate(['loginnew'], {
          queryParams: {
            L: params['L'],
            C: params['C'],
            U: user,
            V: Date.now()
          }
        });
      } else if (params['L'] && params['C']) {
        this.router.navigate(['loginnew'], { queryParams: { L: params['L'], C: params['C'], V: Date.now() } });
      }
    });
  }

  getMyIp(key) {
    this.ecomservice.httpGetOuterResponseHeader(EcomNetworkUtils.GET_IP_ADDRESS + this.ecomservice.GetOlarConfigValue('ipgeolocation_key'), '', false).subscribe((response: HttpResponse<any>) => {
      if (response.status === 200) {
        this.webstorage.localSt_ip = response.body.ip;
        this.webstorage.localSt_latlng = response.body.latitude + ',' + response.body.longitude;
        this.webstorage.localSt_countrycode = response.body.country_code2;
        this.LoadPage(key);
      }
    });
  }

  LoadPage(key) {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
        if (response.isSuccess) {
          if (!this.webstorage.localSt_client_id) {
            this.webstorage.localSt_client_id = response.listValue.oock_client_id;
          }
          // store public key
          this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
          this.initPage(key);
        }
      });
    } else {
      this.initPage(key);
    }
  }

  initPage(key) {
    this.ecomservice.httpGet(EcomNetworkUtils.GET_MESSAGE_URL + '?key=' + key, '', true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
        this.linkExpired = true;
      } else {
        if (response.isSuccess) {
          this.webstorage.sessionSt_is_session_valid = 'YES';
          if (response.listValue.service_type === 'DINE_IN') {
            this.router.navigate(['status-dinein'], { queryParams: { companyId: response.listValue.companyId, serviceId: response.listValue.serviceId } });
          } else if (response.listValue.service_type === 'COLLECTION') {
            this.router.navigate(['status-collection'], { queryParams: { companyId: response.listValue.companyId, serviceId: response.listValue.serviceId } });
          } else if (response.listValue.service_type === 'DELIVERY') {
            this.router.navigate(['status-delivery'], { queryParams: { companyId: response.listValue.companyId, serviceId: response.listValue.serviceId } });
          } else if (response.listValue.service_type === 'RESERVATION') {
            this.router.navigate(['confirm-reservation'], { queryParams: { companyId: response.listValue.companyId, serviceId: response.listValue.serviceId } });
          }
        } else {
          this.linkExpired = true;
        }
      }
    });
  }

}
